import { render } from "./Doctor.vue?vue&type=template&id=12c169b2&ts=true"
import script from "./Doctor.vue?vue&type=script&lang=ts"
export * from "./Doctor.vue?vue&type=script&lang=ts"

import "./Doctor.vue?vue&type=style&index=0&id=12c169b2&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/HeThongPVNB_HV/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__